var roundedBoxesSliderManager = (function () {
    var roundedBoxesCarousel;
    var indexBox = 0;
    var roundedBoxesSliderObj = $(".section.rounded-boxes-slider .owl-carousel");

    function init(){
        $(document).ready(function () {
            if(roundedBoxesSliderObj.length){
                roundedBoxesSliderObj.each(function(){
                    initCarousel($(this));
                    if($(this).parents(".icons-tab-areas-component").length){
                        if($(this).parents(".show.active").length){
                            alignHeight($(this));
                        }
                    } else {
                        alignHeight($(this));
                    }
                })
                
            }
        })

        $(window).on('shown.bs.tab', function (e) {
            owlCarousel = $(".tab-pane.fade.show.active").find(".section.rounded-boxes-slider .owl-carousel").first();
            owlCarousel.owlCarousel();
            owlCarousel.trigger("refresh.owl.carousel");
            owlCarousel.on("refreshed.owl.carousel", function(){
                setTimeout(() => {
                    alignHeight(owlCarousel);
                }, 0);
                
            })
        })
    }

    function alignHeight(el){
        if(ENV.isEditmode) return;
        let roundedBoxes = $(".owl-item .single-rounded-box-container", el);
        let maxHeight = 0;
        roundedBoxes.each(function(){
            currentHeight = $(this).innerHeight();
            if(currentHeight > maxHeight) maxHeight = currentHeight;
        })

        roundedBoxes.each(function(){
            $(this).css('height', maxHeight);
        })
    }

    function initCarousel(el){
        $(".item", el).each( function (k,v){
            if ($(this).hasClass('active')){
                indexBox = k;
            }
        });

        var boxesCount = $(".single-rounded-box-container", el).length;
        var cardsPerRow = el.data("cards-per-row") ? el.data("cards-per-row") : 3
        
        roundedBoxesCarousel = el.owlCarousel({
            mouseDrag: true && !ENV.isEditmode,
            navText: [
                "<i class='fas fa-arrow-left'></i>",
                "<i class='fas fa-arrow-right'></i>"
            ],
            dots: false,
            center: boxesCount > cardsPerRow,
            loop: false,
            responsive:{
                0:{
                    items: 1,
                    stagePadding: 0,
                    singleItem: true,
                    dots: false,
                    center: true,
                    nav:boxesCount > 1
                },
                992: {
                    items: 2,
                    nav:boxesCount > 2
                },
                1200: {
                    items: cardsPerRow,
                    stagePadding: 0,
                    margin: 15,
                    nav:boxesCount > cardsPerRow
                }
            },
            onInitialized: function (e) {
                var target = $(e.target);
                if (target.find('.owl-nav:not(.disabled)').length>0){
                    target.find('.owl-prev').attr('title',LABELS.previous).attr('aria-label',LABELS.previous).removeAttr('role');
                    target.find('.owl-next').attr('title',LABELS.next).attr('aria-label',LABELS.next).removeAttr('role');
                }
            }
        });

        // if(boxesCount > 3 || true){
        //     $(".owl-nav").attr('style', 'display: inherit !important');
        // } else {
        //     $(".owl-nav").attr('style', 'display: none !important');
        // }
    }

    return {
        init: init
    }
})(jQuery);